<template>
    <v-card flat class="subject-card overflow-hidden" :class="{'bordered': !isDark}" @click="openSubject" v-ripple="phoneOnly ? {class: 'ripple--color'} : false">
        <div class="subject-card__header primary d-flex flex-column align-center justify-center text-center px-3">
            <v-icon size="42" color="white">{{ subject.icon || 'mdi-book-education-outline' }}</v-icon>
            <div class="subject-card__title white--text font-weight-bold mt-3">{{ subject.name }}</div>
        </div>
        <div class="subject-card__body px-4 py-4">
            <div class="strong-text--text font-weight-bold mb-3">{{ subject.name }}</div>
            <div class="d-flex justify-space-between mb-1 details-text">
                <span class="muted--text">المدرسين</span>
                <span class="strong-text--text font-weight-medium">{{ subject.teachers_count || 0 }}</span>
            </div>
            <div class="d-flex justify-space-between mb-4 details-text">
                <span class="muted--text">الكورسات</span>
                <span class="strong-text--text font-weight-medium">{{ subject.courses_count || 0 }}</span>
            </div>
            <v-btn block depressed color="primary" dark class="subject-card__btn" @click.stop="openSubject">
                اعرف اكثر
            </v-btn>
        </div>
    </v-card>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'

export default {
    props: {
        subject: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...GlobalComputed,
    },
    methods: {
        openSubject() {
            this.$router.push({ name: 'subject-teachers', params: { id: this.subject.id } });
        },
    },
};
</script>

<style lang="scss" scoped>
.subject-card {
    border-radius: 16px !important;
    height: 100%;
    cursor: pointer;
}

.subject-card__header {
    min-height: 130px;
    background: radial-gradient(circle at 50% 15%, rgba(255, 255, 255, 0.1), transparent 55%);
}

.subject-card__title {
    font-size: 1rem;
    line-height: 1.4;
}

.subject-card__body {
    background: #fff;
}

.theme--dark .subject-card__body {
    background: var(--v-surface-base);
}

.subject-card__btn {
    border-radius: 10px !important;
    text-transform: none;
    font-weight: 600;
}
</style>
